import React, { useEffect, useState } from 'react';

import { Link, Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { Translate } from '@change-corgi/core-react/i18n';

import { ANIMATION_WORD_DELAY_MS, FEEDBACK_LINKS_INITIAL_DELAY_MS } from '../utils/feedbackStorageUtils';

const FEEDBACK_LINK_CLASS = 'text-interactive text-blue-800 [&>span]:leading-[20px]!' as const;
const REVEAL_CLASS = 'inline-block transition-all duration-t5 ease-out' as const;

export const AiSummaryFeedbackLinksStaggered: React.FC<AiSummaryFeedbackLinksStaggeredProps> = ({ onFeedback }) => {
	const [step, setStep] = useState(0);

	useEffect(() => {
		const yesTimer = setTimeout(() => {
			setStep(1);
		}, FEEDBACK_LINKS_INITIAL_DELAY_MS);
		const bulletTimer = setTimeout(() => {
			setStep(2);
		}, FEEDBACK_LINKS_INITIAL_DELAY_MS + ANIMATION_WORD_DELAY_MS);
		const noTimer = setTimeout(
			() => {
				setStep(3);
			},
			FEEDBACK_LINKS_INITIAL_DELAY_MS + 2 * ANIMATION_WORD_DELAY_MS,
		);
		return () => {
			clearTimeout(yesTimer);
			clearTimeout(bulletTimer);
			clearTimeout(noTimer);
		};
	}, []);

	return (
		<div className="flex items-center gap-2.5">
			<span className={cn(REVEAL_CLASS, step >= 1 ? 'translate-y-0 opacity-100' : 'translate-y-1 opacity-0')}>
				<Link
					as="button"
					bold
					className={FEEDBACK_LINK_CLASS}
					data-qa="ai-summary-feedback-yes"
					onClick={() => onFeedback(true)}
					size="small"
					tabIndex={step >= 1 ? undefined : -1}
					type="button"
					underline={false}
				>
					<Translate value="corgi.petition_details.ai_summary.feedback_yes" />
				</Link>
			</span>
			<span
				aria-hidden
				className={cn(REVEAL_CLASS, step >= 2 ? 'translate-y-0 opacity-100' : 'translate-y-1 opacity-0')}
			>
				<Text aria-hidden className="text-typography-weak" size="small" variant="body">
					•
				</Text>
			</span>
			<span className={cn(REVEAL_CLASS, step >= 3 ? 'translate-y-0 opacity-100' : 'translate-y-1 opacity-0')}>
				<Link
					as="button"
					bold
					className={FEEDBACK_LINK_CLASS}
					data-qa="ai-summary-feedback-no"
					onClick={() => onFeedback(false)}
					size="small"
					tabIndex={step >= 3 ? undefined : -1}
					type="button"
					underline={false}
				>
					<Translate value="corgi.petition_details.ai_summary.feedback_no" />
				</Link>
			</span>
		</div>
	);
};

type AiSummaryFeedbackLinksStaggeredProps = Readonly<{
	onFeedback: (helpful: boolean) => void;
}>;
